import { render } from "./ticket-list-event.vue?vue&type=template&id=535a379e"
import script from "./ticket-list-event.vue?vue&type=script&lang=js"
export * from "./ticket-list-event.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__